import { render, staticRenderFns } from "./storage-card.vue?vue&type=template&id=1dfa7b37&scoped=true&"
import script from "./storage-card.vue?vue&type=script&lang=js&"
export * from "./storage-card.vue?vue&type=script&lang=js&"
import style0 from "./storage-card.vue?vue&type=style&index=0&id=1dfa7b37&lang=scss&scoped=true&"
import style1 from "./storage-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa7b37",
  null
  
)

export default component.exports